import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import Constants from './constants';
import InviteUserRecord from './data/InviteUserRecord';

function getInitialState() {
  return new InviteUserRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<InviteUserRecord> = (state = defaultState, action) => {
  switch (action.type) {
    case Constants.CLOSE_INVITE_USER_MODAL:
      return getInitialState();

    case Constants.OPEN_INVITE_USER_MODAL:
      return state.set('isModalOpen', true);

    case Constants.SEND_USER_INVITE_REQUEST:
      return state.merge({
        isSubmitting: true,
        isInviteSent: false,
        error: undefined,
      });

    case Constants.SEND_USER_INVITE_REQUEST_SUCCESS:
      return state.merge({
        isSubmitting: false,
        isInviteSent: true,
      });

    case Constants.SEND_USER_INVITE_REQUEST_ERROR:
      return state.merge({
        isSubmitting: false,
        isInviteSent: false,
        error: new ErrorRecord(
          typeof action.error === 'object' && action.error !== null ? action.error : undefined
        ),
      });

    default:
      return state;
  }
};

export default reducer;
